import axios from 'axios'
import store from '../store';

const api_instance = axios.create({
  baseURL: getUrl(),
  timeout: 60000
})

api_instance.interceptors.request.use(
  config => {
    const token = $cookies.get('jwt')
    if (token != null) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  }
)

api_instance.interceptors.response.use(null, (error) => {
  if(error.response.status === 401) {
    store.dispatch('logout', 'Login')
  }
  return error.response;
})

export const instance = api_instance

// Get the base url for the API based on production or development.
function getUrl () {
  // CBTODO -- This will be different in the dev environment. Can we make this easier across environments?
  if (process.env.NODE_ENV === 'development') 
    return 'http://localhost:5000'
  return location.origin + '/api'
}
